import { SafetyCertificateOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import { useState } from 'react';
import { weixinChannelsAccountCookieCheck } from '../api';
import { resolveErrorMessage } from '../utils/errorMessage';
import SocialAccountLoginButton from './SocialAccountLoginButton';

const isWeixinChannelsAccount = (account) => {
  const platform = String(account?.platform || '').trim();
  const platformCode = String(account?.platform_code || '').trim();
  return (
    platformCode === 'weixin_channels'
    || platform === '微信视频号'
    || platform === '视频号'
    || platform === 'weixin_channels'
  );
};

const WeixinChannelsAccountCheckButton = ({
  account,
  size = 'small',
  type = 'link',
  label = '检测',
  disabled = false,
  onSuccess,
  buttonProps = {},
}) => {
  const [checking, setChecking] = useState(false);
  const [autoLoginKey, setAutoLoginKey] = useState(0);
  const [autoLoginToken, setAutoLoginToken] = useState('');

  if (!isWeixinChannelsAccount(account)) return null;

  const accountId = account?.account_id;

  const handleCheck = async () => {
    if (!accountId) {
      message.error('缺少 account_id');
      return;
    }
    setChecking(true);
    try {
      const resp = await weixinChannelsAccountCookieCheck({ account_id: accountId, persist: false });
      if (resp?.status !== 'success') {
        const fallback = `检测失败：${resp?.status || 'unknown'}`;
        message.error(resolveErrorMessage(resp?.error_message || resp?.error, fallback));
        return;
      }
      if (resp?.is_valid) {
        message.success('cookies 有效，可正常发布');
      } else {
        const reason = String(resp?.reason || '').trim();
        const reasonCode = reason.toLowerCase();
        const reasonText = resolveErrorMessage(reason);
        message.error(reasonText ? `cookies 已失效：${reasonText}` : 'cookies 已失效，请重新扫码登录');
        if (reasonCode === 'cookie_invalid') {
          setAutoLoginToken(`${Date.now()}-${Math.random().toString(36).slice(2, 8)}`);
          setAutoLoginKey((k) => k + 1);
        }
      }
      if (typeof onSuccess === 'function') onSuccess(resp);
    } catch (error) {
      console.error('微信视频号 cookies 检测失败:', error);
      const errText = resolveErrorMessage(error?.message || String(error));
      message.error(errText ? `检测失败：${errText}` : '检测失败，请稍后重试');
    } finally {
      setChecking(false);
    }
  };

  return (
    <>
      <Button
        type={type}
        size={size}
        icon={<SafetyCertificateOutlined />}
        onClick={handleCheck}
        loading={checking}
        disabled={disabled || checking}
        {...buttonProps}
      >
        {label}
      </Button>
      {autoLoginKey > 0 && (
        <SocialAccountLoginButton
          key={`weixin-channels-auto-login-${autoLoginKey}`}
          account={account}
          autoStart
          autoStartToken={autoLoginToken || `cookie-check-${autoLoginKey}`}
          buttonProps={{ style: { display: 'none' } }}
        />
      )}
    </>
  );
};

export default WeixinChannelsAccountCheckButton;
